import {Unit} from './unit.model';
import {AppSettings} from '../settings/app.settings';

export class Hour{
    id: number;
    initTime: Date;
    endTime: Date;
    quota: number;
}
export class ProductOption{
    active:boolean;
    checkWheelChair:boolean;
    id:number;
    name:string;
    description:string;
    duration:number;
    durationName:string;
    languageLive: string[];
    languageGuide: string[];
    selectedHour: any;
    date:Date;
    hours: Hour[];
    units: Unit[];
    mobileAccess: boolean;
    smallImage:string;
    mediumImage:string;
    groupedOption:boolean;
    groupingAttributes:any;
    groupedOptionList: ProductOption[];
    scaledPricing: any;
    total:number;
    vehicleId:number;
    vehicleName:string;
    highPrice: number;
    filter:any = {};
    vip:boolean = false;
    promotion: any;
    newPrice:any;
    freeCancellation:boolean;
    nominativeVoucher: boolean;

    get durationsAvailables(){
        if(this.groupingAttributes != null && this.groupingAttributes["DURATION"]){
            return this.groupingAttributes["DURATION"].map(dur => {
                let time = dur.split("_")[0];
                let unit = dur.split("_")[1].toUpperCase();
                let caltime = this.calculeTime(time,unit);
                return { duration: caltime, durationName: unit, originalDuration: parseInt(time) };
            });
        }else{
            let time:number = this.duration; // Duration always arrives in 'minutes' 
            let type:string = this.durationName.toUpperCase();
            this.durationName = type;
            time = this.calculeTime(time,type);
            return [{ duration: time, durationName: this.durationName, originalDuration: this.duration}]
        }
    }

    get vehiclesAvailable(){
        if(this.groupingAttributes != null && this.groupingAttributes["VEHICLE"]){
            return this.groupingAttributes["VEHICLE"].map(vehicle => {
                return {vehicleName: vehicle};
            });
        }else{
            return [{vehicleName: this.vehicleName}];
        }
    }

    get vipAvailable(){
        if(this.groupingAttributes != null && this.groupingAttributes["VIP"].length>1){
            return this.groupingAttributes["VIP"] != null
        }else{
            return this.vip;
        }
    }
    
    private calculeTime(duration, type){
        if(type == 'HOUR'){
            duration /= 60; 
        }else if(type == "DAY"){
            duration /= 60*24; 
        }
        return duration;
    }
}